<div [class]="cssClasses">
  @if (icon) {
  <mat-icon [svgIcon]="icon"></mat-icon>
  }
  <div class="notification-area_message">
    <div class="notification-area_heading">{{ message.heading }}</div>

    <ng-container>
      @for (descriptionRow of message.descriptionList; track descriptionRow) {
      <div class="notification-area_description">
        <faxe-html-display [htmlString]="descriptionRow"> </faxe-html-display>
      </div>
      }
    </ng-container>
    @for (bullet of message.bulletList; track bullet) {
    <ul>
      <li>{{ bullet }}</li>
    </ul>
    }
  </div>
  <button mat-icon-button (click)="removeNotification()">
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</div>
